import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useMatches } from 'react-router';
import { Toaster } from '@/components/ui/toaster';
import { routePattern, trackPageView } from '@/lib/analytics';

/** Counts one page view per route change (anonymously; see lib/analytics.ts). */
function PageViews() {
  const { pathname } = useLocation();
  const matches = useMatches();
  const pattern = routePattern(pathname, matches);
  useEffect(() => trackPageView(pattern), [pattern]);
  return null;
}

export function RootLayout() {
  const { t } = useTranslation();
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:start-3 focus:top-3 focus:z-[200] focus:rounded-md focus:bg-paper focus:px-3 focus:py-2 focus:text-paper-ink"
      >
        {t('app.skipToContent')}
      </a>
      <Outlet />
      <PageViews />
      <Toaster />
    </>
  );
}
